var map = {
	"./level1_1.webp": [
		465,
		3
	],
	"./level1_2.webp": [
		466,
		4
	],
	"./level1_3.webp": [
		467,
		5
	],
	"./level1_4.webp": [
		468,
		6
	],
	"./level1_5.webp": [
		469,
		7
	],
	"./level2_1.webp": [
		470,
		8
	],
	"./level2_2.webp": [
		471,
		9
	],
	"./level2_3.webp": [
		472,
		10
	],
	"./level2_4.webp": [
		473,
		11
	],
	"./level2_5.webp": [
		474,
		12
	],
	"./level3_1.webp": [
		475,
		13
	],
	"./level3_2.webp": [
		476,
		14
	],
	"./level3_3.webp": [
		477,
		15
	],
	"./level3_4.webp": [
		478,
		16
	],
	"./level3_5.webp": [
		479,
		17
	],
	"./level4_1.webp": [
		480,
		18
	],
	"./level4_2.webp": [
		481,
		19
	],
	"./level4_3.webp": [
		482,
		20
	],
	"./level4_4.webp": [
		483,
		21
	],
	"./level4_5.webp": [
		484,
		22
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 328;
module.exports = webpackAsyncContext;